import { useCallback } from 'react';

const SEARCH_HISTORY_KEY = 'manhwa_search_history';
const MAX_HISTORY_ITEMS = 20;

export const useSearchHistory = () => {

    const saveSearchToHistory = useCallback(async (query: string) => {
        if (!query.trim()) return;

        try {
            console.log('Saving search to localStorage:', query);

            // Get existing history
            const existingHistory = getSearchHistoryFromStorage();

            // Remove duplicate if exists
            const filteredHistory = existingHistory.filter(item => item.search_query !== query);

            // Add new search to the beginning
            const newHistory = [
                {
                    search_query: query.trim(),
                    created_at: new Date().toISOString()
                },
                ...filteredHistory
            ].slice(0, MAX_HISTORY_ITEMS); // Keep only the latest 20 searches

            // Save to localStorage
            localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(newHistory));
            console.log('Search saved to localStorage successfully');
        } catch (error) {
            console.error('Error saving search to localStorage:', error);
        }
    }, []);

    const loadSearchHistory = useCallback(async (limit: number = 10) => {
        try {
            const history = getSearchHistoryFromStorage();
            console.log('Loaded search history from localStorage:', history);
            return history.slice(0, limit);
        } catch (error) {
            console.error('Error loading search history from localStorage:', error);
            return [];
        }
    }, []);

    const clearSearchHistory = useCallback(async () => {
        try {
            localStorage.removeItem(SEARCH_HISTORY_KEY);
            console.log('Search history cleared from localStorage');
            return true;
        } catch (error) {
            console.error('Error clearing search history from localStorage:', error);
            return false;
        }
    }, []);

    const removeSearchFromHistory = useCallback(async (queryToRemove: string) => {
        try {
            console.log('Removing search from localStorage:', queryToRemove);

            // Get existing history
            const existingHistory = getSearchHistoryFromStorage();

            // Remove the specific search
            const filteredHistory = existingHistory.filter(item => item.search_query !== queryToRemove);

            // Save updated history
            localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(filteredHistory));
            console.log('Search removed from localStorage successfully');
            return true;
        } catch (error) {
            console.error('Error removing search from localStorage:', error);
            return false;
        }
    }, []);

    const getSearchHistoryFromStorage = () => {
        try {
            const stored = localStorage.getItem(SEARCH_HISTORY_KEY);
            return stored ? JSON.parse(stored) : [];
        } catch (error) {
            console.error('Error parsing search history from localStorage:', error);
            return [];
        }
    };

    return {
        saveSearchToHistory,
        loadSearchHistory,
        clearSearchHistory,
        removeSearchFromHistory,
        isAuthenticated: true // Always true for localStorage
    };
}; 